import { createRoute, Outlet } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { SheetsLibrary } from "@/features/documents/components/sheets-library";

/** Layout passthrough so `/sheets` (library) and `/sheets/$pageId` (editor) coexist. */
function SheetsLayout() {
  return (
    <div class="flex h-full min-h-0 flex-1">
      <Outlet />
    </div>
  );
}

export const sheetsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/sheets",
  component: SheetsLayout,
});

export const sheetsIndexRoute = createRoute({
  getParentRoute: () => sheetsRoute,
  path: "/",
  component: SheetsLibrary,
});
